import { IconButton, Input, Tooltip } from "@evergis/ui";
import { Flex } from "grid-styled";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { LabelContainer, LabelWrapper } from "./styled";
import { AddProxyServiceContextType, ProxyServiceType } from "./types";

export type ProxyServiceURLProps = Pick<
  AddProxyServiceContextType,
  "sourceUrl" | "setSourceUrl" | "serviceType" | "subDomainsValue" | "setSubDomainsValue"
>;

export const ProxyServiceURL: FC<ProxyServiceURLProps> = ({
  sourceUrl,
  setSourceUrl,
  serviceType,
  subDomainsValue,
  setSubDomainsValue,
}) => {
  const { t } = useTranslation("dialogs");

  return (
    <Flex alignItems={"center"}>
      <Input
        type="text"
        label={t("addProxyService.serverURL")}
        value={sourceUrl}
        onChange={event => setSourceUrl(event.target.value)}
        width={serviceType !== ProxyServiceType.TMS ? "100%" : "39.625rem"}
      />
      {serviceType === ProxyServiceType.TMS && (
        <Input
          style={{ marginLeft: "1rem" }}
          type="text"
          label={
            <LabelWrapper>
              <LabelContainer>
                <span>{t("addProxyService.subDomains")}</span>
                <Tooltip arrow placement={"top"} content={t("addProxyService.subDomainsInfo")}>
                  {ref => <IconButton innerRef={ref} kind={"info"} />}
                </Tooltip>
              </LabelContainer>
            </LabelWrapper>
          }
          value={subDomainsValue}
          onChange={event => setSubDomainsValue(event.target.value)}
          width="12.25rem"
        />
      )}
    </Flex>
  );
};
